module.exports = __webpack_public_path__ + "img/5.9.TU.313392df.png";